export function getWebComponentHost(
  container?: HTMLElement
): HTMLElement | undefined {
  if (!container) return undefined
  if (container instanceof ShadowRoot) return container.host as HTMLElement
  const root = container.getRootNode()
  if (root instanceof ShadowRoot) return root.host as HTMLElement
  return undefined
}

export function readHostAttribute(
  container: HTMLElement | undefined,
  attribute: string
): string | undefined {
  const host = getWebComponentHost(container)
  if (!host?.hasAttribute(attribute)) return undefined
  const value = host.getAttribute(attribute)
  return value == null ? undefined : value
}

export function resolveHostFlag(
  prop: boolean | string | undefined,
  container: HTMLElement | undefined,
  attribute: string
): boolean {
  const host = getWebComponentHost(container)
  if (host?.hasAttribute(attribute)) {
    const raw = (host.getAttribute(attribute) ?? "").trim().toLowerCase()
    if (raw === "false" || raw === "0" || raw === "no" || raw === "off") {
      return false
    }
    return true
  }
  return prop === true || prop === "true"
}
